import { EntityActionNames, IEntityAction } from '../../app/spaces/ActionsMenu/EntityActions/IEntityAction';
import { anyEnabledSchedule, userCanEditSchedule } from '../../app/spaces/ActionsMenu/EntityActions/IEntityActionHelpers';
import { AppState } from '../../app/state/AppState';
import { Messages } from '../../codegen/Localize';
import { IScheduleInfo } from '../types/IScheduleInfo';
import { scheduleDisable } from './ScheduleMenuActions';

export const ScheduleDisableAction: IEntityAction<IScheduleInfo, {}> = {
  name: EntityActionNames.DisableSchedules,
  translateName: Messages.disable_action,
  isVisible: (targetItems: IScheduleInfo[], state: AppState) => {
    return targetItems.length > 0 && userCanEditSchedule(state, targetItems);
  },
  isClickable: (_availableActions: {}, targetItems: IScheduleInfo[]) => {
    return anyEnabledSchedule(targetItems);
  },
  createReduxAction: (targetItems: IScheduleInfo[]) => scheduleDisable(targetItems)
};
